import default_avatar from '@/assets/images/default_avatar.png';
import { Select } from 'antd';
import { LabeledValue } from 'antd/es/select';
import { CustomTagProps } from 'rc-select/lib/BaseSelect';
import React from 'react';
import { IconFont } from '../../IconFont';
import { EMemberType } from '../../MemberSelectModal/interface';
import { IOption } from '../type';
import styles from './index.less';

interface IProps {
  options: IOption[];
  value?: IOption[];
  showSelectModal: () => void;
  onChange?: (value: IOption[]) => void;
}

export const CustomSelect: React.FC<IProps> = (props) => {
  const { value = [], options, onChange, showSelectModal } = props;

  const tagRender = (props: CustomTagProps) => {
    const { label, value, onClose } = props || {};
    const avatar = value?.split('_')[1]; // 当为部门或组织时候没有url，拿到的是'undefined',角色是''
    const type = value?.split('_')[2];
    return (
      <div
        key={value}
        className="flex items-center h-7 p-1 pr-2 mb-1 rounded-[14px] bg-active hover:bg-[#EAECEF]"
      >
        {Number(type) === EMemberType.DEPARTMENT ? (
          <IconFont type="icon-bumen" className="text-[20px] mr-1" />
        ) : (
          <img
            className="w-5 h-5 rounded-half mr-1"
            src={avatar || default_avatar}
            alt="avatar"
          />
        )}

        <p className="max-w-24 mr-2 truncate ">{label}</p>
        <button
          type="button"
          className="text-[#8B8F97] text-sm"
          onClick={() => onClose()}
        >
          <IconFont type="icon-guanbi" />
        </button>
      </div>
    );
  };

  const handleSelect = (option: IOption) => {
    onChange?.([...value, option]);
  };

  const handleDeselect = (key: string | number | LabeledValue) => {
    const _value = key as string;
    onChange?.(value.filter((v) => v.value !== _value));
  };

  return (
    <Select
      mode="multiple"
      className={`${styles['cm-select']} w-[220px]`}
      // style={{ maxHeight: 76, overflow: 'auto' }}
      placeholder="请选择负责人"
      value={value}
      showSearch={true}
      optionFilterProp="label"
      options={options}
      tagRender={tagRender}
      listItemHeight={32}
      onSelect={(_, option: IOption) => handleSelect(option)}
      onDeselect={(key) => handleDeselect(key)}
      filterOption={(inputValue, option) =>
        option?.label ? option.label.includes(inputValue) : false
      }
      optionRender={(option) => (
        <div key={option.key} className="flex items-center h-full">
          <img
            className="w-5 h-5 mr-2 rounded-half"
            src={option?.data.avatar || default_avatar}
            alt="avatar"
          />
          <p className="flex-1 min-w-0 text-wrap">{option.label}</p>
        </div>
      )}
      dropdownRender={(menu) => {
        return (
          <>
            {menu}
            <div
              onClick={showSelectModal}
              className="flex items-center px-2 py-1  text-primary cursor-pointer"
            >
              <IconFont type="icon-tianjia" className="text-base mr-1" />
              <p>从组织架构中添加</p>
            </div>
          </>
        );
      }}
    />
  );
};
